<template>
  <PackageCreatedSuccessDialog />
</template>

<script setup>
import PackageCreatedSuccessDialog from './PackageCreatedSuccessDialog.vue'
</script>
